import { Navigate} from "react-router-dom";


export const isLoggedIn = () =>  {
    return localStorage.getItem('user') !== null;
}


export const validateLoggedIn = () => {
    if (isLoggedIn() === false) {
        alert("You are not logged in.");
        return <Navigate replace to="/login" />
    }
}


export const getSession = () =>  {
    return JSON.parse(localStorage.getItem('user'));
}


export const logOut = () =>  {
    if (isLoggedIn()) {
        localStorage.removeItem('user');
        return true
    } else {
        return false
    }
}